import { render } from "./BuyingZoneCmsLink.vue?vue&type=template&id=676394e8"
import script from "./BuyingZoneCmsLink.vue?vue&type=script&lang=js"
export * from "./BuyingZoneCmsLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__